export default __webpack_public_path__ + "static/media/img-0180-spain-premium-face.ed234f79.png";